import React, { useMemo } from 'react';
import Legend from './Legend';
import { reverseColorMapping } from '../utils/puzzleUtils';

const SolutionRenderer = ({ solution, gridSize, highlightedPiece, setHighlightedPiece }) => {
    const pieceMap = useMemo(() => {
      const map = new Map();
      let pieceId = 0;
      solution.forEach(row => {
        row.forEach(cell => {
          const [piece] = cell.split('-');
          if (!map.has(piece)) {
            map.set(piece, pieceId++);
          }
        });
      });
      return map;
    }, [solution]);

  const getBorderStyle = (row, col, piece) => {
    const style = {};
    const borderColor = 'white';
    const borderWidth = '2px';

    if (row === 0) style.borderTop = `${borderWidth} solid ${borderColor}`;
    if (col === 0) style.borderLeft = `${borderWidth} solid ${borderColor}`;
    if (col === gridSize - 1) style.borderRight = `${borderWidth} solid ${borderColor}`;
    if (row === gridSize - 1) style.borderBottom = `${borderWidth} solid ${borderColor}`;

    if (row > 0 && solution[row - 1][col].split('-')[0] !== piece) {
      style.borderTop = `${borderWidth} solid ${borderColor}`;
    }
    if (col > 0 && solution[row][col - 1].split('-')[0] !== piece) {
      style.borderLeft = `${borderWidth} solid ${borderColor}`;
    }

    return style;
  };

  const handleCellClick = (piece) => {
    setHighlightedPiece(prev => prev === piece ? null : piece);
  };

  return (
    <div className="solution-box">
      <div className="solution-grid" style={{ gridTemplateColumns: `repeat(${gridSize}, 1fr)` }}>
        {solution.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            {row.map((cell, colIndex) => {
              const [piece, color] = cell.split('-');
              const pieceNumber = pieceMap.get(piece);
              const borderStyle = getBorderStyle(rowIndex, colIndex, piece);

              return (
                <div
                  key={colIndex}
                  className={`solution-cell piece-${pieceNumber} ${highlightedPiece === piece ? 'highlighted-piece' : ''}`}
                  style={{
                    backgroundColor: reverseColorMapping[color],
                    ...borderStyle
                  }}
                  onClick={() => handleCellClick(piece)}
                >
                  <span className="piece-number">{pieceNumber}</span>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
      <Legend pieceMap={pieceMap} highlightedPiece={highlightedPiece} setHighlightedPiece={setHighlightedPiece} />
    </div>
  );
};

export default SolutionRenderer;